var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_14_1",
    "data-name": "Component 14 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 76.7,
    height: 76.7,
    viewBox: "0 0 87 87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M1027.333,453.646c-23.1,0-41.832,20.072-41.832,44.832s18.729,44.832,41.832,44.832,41.832-20.072,41.832-44.832C1069.142,473.728,1050.427,453.671,1027.333,453.646Zm9.2,45.721h-8.438v8.9h-1.66v-8.9h-8.3v-1.779h8.3v-8.894h1.66v8.894h8.438Z",
    transform: "translate(-983.833 -451.978)",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88",
    "data-name": "Group 88"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M1027.333,452.1a43.375,43.375,0,1,0,43.375,43.375A43.375,43.375,0,0,0,1027.333,452.1Zm0,85.384a42.009,42.009,0,1,1,42.009-42.009A42.009,42.009,0,0,1,1027.333,537.487Z",
    transform: "translate(-983.833 -451.978)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M1027.333,538.978a43.5,43.5,0,0,1,0-87h0a43.5,43.5,0,1,1,0,87Zm0-86.779a43.34,43.34,0,1,0,30.584,12.694,43.327,43.327,0,0,0-30.584-12.694Zm0,85.412a42.134,42.134,0,1,1,42.134-42.134A42.182,42.182,0,0,1,1027.333,537.612Zm0-84.046a41.912,41.912,0,1,0,41.912,41.912A41.96,41.96,0,0,0,1027.333,453.566Z",
    transform: "translate(-983.833 -451.978)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutline);
export default __webpack_public_path__ + "static/media/outline.c00045b6.svg";
export { ForwardRef as ReactComponent };